import type { QuickPrompt } from '@coursera-web/wes-common';

import _t from 'i18n!nls/teams-v2';

export const getTeamsCoachQuickPrompts = (): QuickPrompt[] => [
  {
    key: 'wes-funnel-whats-included',
    prompt: _t('What’s included in the Team plan?'),
  },
  {
    key: 'wes-funnel-billing-info',
    prompt: _t('Can I add licenses later?'),
  },
  {
    key: 'wes-funnel-change-licenses',
    prompt: _t('Do you offer invoice payment?'),
  },
];
